'use strict';

// specific JS for child-theme

require('./modules/headings');